module.exports = __webpack_public_path__ + "img/coming-soon-PC.7ebc013f.jpg";